import shareTip from '../assets/img/shareTip.png'
import appFunction from './appFunction.js'
import store from '../store/index'
import axios from 'axios';

let util = {
    phoneReg: /^1([38][0-9]|4[5-9]|5[0-3,5-9]|66|7[0-8]|9[0-9])[0-9]{8}$/,
    bankReg: /^([1-9]{1})(\d{14}|\d{18})$/,
};

util.appFunction = appFunction;
util.title = function(title) {
    window.document.title = title;
};
/**
 * 数字转整数 如 100000 转为10万
 * @param {需要转化的数} num
 * @param {需要保留的小数位数} point
 */
util.tranNumber = function(num, point) {
        let numStr = num.toString()
            // 十万以内直接返回
        if (numStr.length < 6) {
            return numStr;
        }
        //大于8位数是亿
        else if (numStr.length > 8) {
            let decimal = numStr.substring(numStr.length - 8, numStr.length - 8 + point);
            return parseFloat(parseInt(num / 100000000) + '.' + decimal) + '亿';
        }
        //大于6位数是十万 (以10W分割 10W以下全部显示)
        else if (numStr.length > 5) {
            let decimal = numStr.substring(numStr.length - 4, numStr.length - 4 + point)
            return parseFloat(parseInt(num / 10000) + '.' + decimal) + '万';
        }
    }
    /**
     ** s:数字
     ** p:小数位
     ** z:是否补0,true为补0，false：不补
     */
util.toFixed = function(s, p, z) {
    if (s === 0) return p === 2 ? '0.00' : '0';
    if (!s) return;
    let n = (parseInt(s * Math.pow(10, p) + (s > 0 ? 0.5 : -0.5)) / Math.pow(10, p)).toFixed(p).toString();
    if (z) {
        let i = n.indexOf(".");
        if (i < 0 && p > 0) {
            n = n + ".";
            for (let i = 0; i < p; i++) {
                n = n + "0";
            }
        } else {
            i = n.length - i;
            for (let j = 0; j < (p - i) + 1; j++) {
                n = n + "0";
            }
        }
    }
    return n;
}
util.format = function(r, a, t) {
    a = a || "Y-M-D h:m:s";
    let e = function(e, r) {
        return (!r && 10 > e ? "0" : "") + e
    };
    for (var c = r.getTime ? r : new Date(r), s = a.length, g = a, n = 0; s > n; n++) switch (a.charAt(n)) {
        case "Y":
            g = g.replace(/Y/g, e(c.getFullYear(), t));
            break;
        case "y":
            g = g.replace(/y/g, e(c.getFullYear(), t).substring(2));
            break;
        case "M":
            g = g.replace(/M/g, e(c.getMonth() + 1, t));
            break;
        case "D":
            g = g.replace(/D/g, e(c.getDate(), t));
            break;
        case "h":
            g = g.replace(/h/g, e(c.getHours(), t));
            break;
        case "m":
            g = g.replace(/m/g, e(c.getMinutes(), t));
            break;
        case "s":
            g = g.replace(/s/g, e(c.getSeconds(), t))
    }
    return g
}
util.toast = function(obj) {
    let opt = {
        duration: 1500,
        msg: '',
        type: 'succ'
    }
    opt = Object.assign(opt, obj);
    if (document.querySelector('.bit-toast')) return;
    let _toast = document.createElement('div');
    var _toast1 = document.createElement('div');
    _toast.setAttribute('class', 'bit-toast');
    _toast1.setAttribute('class', 'bit-toast-content');
    _toast1.innerHTML = opt.msg;
    _toast.appendChild(_toast1);
    document.body.appendChild(_toast);
    let o = document.querySelector('.bit-toast');
    setTimeout(() => {
        o.className = 'bit-toast bit-toast-op ' + opt.type;
    }, 10);

    function opNone() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                o.className = 'bit-toast ' + opt.type;
                resolve();
            }, 1000);
        })
    };
    opNone().then((res) => {
        setTimeout(() => {
            document.body.removeChild(o);
        }, 500);
    });

}
util.showLoading = function() {
    var loading = document.createElement('div');
    var loadingIcon = document.createElement('i');
    loading.setAttribute('class', 'loading');
    loadingIcon.setAttribute('class', 'loadingIcon');
    loading.appendChild(loadingIcon);
    document.body.appendChild(loading);
}
util.hideLoading = function() {
    var o = document.querySelector('.loading');
    if (o) {
        document.body.removeChild(o);
    }
}
util.moneyFormat = function(money, num) {
    money = money + '';
    let point = money.split('.');
    if (point[0].length > 8) {
        let n = num || num == 0 ? num : 2;
        money = (money / 100000000).toFixed(n) + '亿';
    } else if (point[0].length > 4) {
        let n1 = num || num == 0 ? num : 2;
        money = (money / 10000).toFixed(n1) + '万';
    } else {
        let n2 = num || num == 0 ? num : 2;
        money = (money - 0).toFixed(n2)
    }
    return money;
}
util.removeLabel = function(content) {
    var temp = content.replace(/<\/?.+?>/g, "");
    var result = temp.replace(/ /g, ""); //result为得到后的内容
    return result;
}
util.removeStyle = function(content, style) {
    if (content) {
        var reg = new RegExp(style, 'g');
        var content1 = content.replace(reg, '');
        return content1;
    }
}
util.showCount = function(count, text) {
    return count ? (count >= 10000 ? (count / 10000).toFixed(1) + (text ? '万' : "w") : count) : 0;
}
util.formatSeconds = function(time) {
    if (time > 0) {
        var theTime = Math.round(time); // 秒
        var middle = 0; // 分
        if (theTime >= 60) {
            middle = parseInt(theTime / 60);
            theTime = parseInt(theTime % 60);
        }
        var result =
            (middle >= 10 ? middle : "0" + middle) +
            ":" +
            (theTime >= 10 ? theTime : "0" + theTime);
        return result;
    } else {
        return "00:00";
    }
}
util.showWeek = function(time) {
    var weekBox = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
    var weekIndex = new Date(time).getDay();
    return weekBox[weekIndex];
}
util.changeTime = function(obj) {
    var newDate = new Date(obj.time);
    var time = newDate.getTime();
    var year = newDate.getFullYear();
    var mon = newDate.getMonth() + 1;
    mon = mon >= 10 ? mon : "0" + mon;
    var day = newDate.getDate();
    day = day >= 10 ? day : "0" + day;
    var hour = newDate.getHours() < 10 ? "0" + newDate.getHours() : newDate.getHours();
    var min = newDate.getMinutes() < 10 ? "0" + newDate.getMinutes() : newDate.getMinutes();
    var seconds = newDate.getSeconds() < 10 ? "0" + newDate.getSeconds() : newDate.getSeconds();
    var str = mon + (obj.line ? (obj.line == 'text' ? '月' : obj.line) : "-") + day + (obj.line == 'text' ? '日' : " ");
    if (obj.showWeek) {
        str += '（' + this.showWeek(obj.time) + '）'
    }
    if (obj.showMin) {
        str += hour + ':' + min
    }
    if (obj.showSeconds) {
        str += hour + ':' + min + ":" + seconds
    }
    if (!obj.hideYear) {
        str = year + (obj.line ? (obj.line == 'text' ? '年' : obj.line) : "-") + str
    }
    return str
}
util.friendlyTime = function(endTime, startTime, showMin) {
    if (endTime - startTime > 0) {
        var time = parseInt(endTime - startTime);
        var days = parseInt(time / (1000 * 60 * 60 * 24));
        var hours = parseInt((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = parseInt((time % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = (time % (1000 * 60)) / 1000;
        if (days > 2) {
            var endYear = new Date(endTime).getFullYear();
            var startYear = new Date(startTime).getFullYear();
            if (endYear != startYear) {
                return showMin ? this.changeTime({
                    time: startTime,
                    line: '-',
                    showMin: true
                }) : this.changeTime({
                    time: startTime,
                    line: '-'
                });
            } else {
                return showMin ? this.changeTime({
                    time: startTime,
                    line: '-',
                    showMin: true
                }) : this.changeTime({
                    time: startTime,
                    line: '-'
                });
            }
        } else {
            if (days > 0) {
                return days + "天前";
            } else {
                if (hours > 0) {
                    return hours + "小时前";
                } else {
                    if (minutes > 0) {
                        return minutes + "分钟前";
                    } else {
                        return "刚刚";
                    }
                }
            }
        }
    } else {
        return "";
    }
};
util.getQueryString = function(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}
util.vueGetQueryString = function(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
}
util.setCookie = function(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}
util.getCookie = function(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}
util.loginStatus = function() {
    if (localStorage.getItem("authorization") && typeof(localStorage.getItem("authorization") != 'undefined')) {
        return true;
    } else {
        return false;
    }
}
util.loginAgain = function() {
    localStorage.setItem('enterUrl', window.location.href);
    localStorage.removeItem('authorization');
    if (sessionStorage.getItem('ua') == 'wechat') {
        util.wechatLogin();
    } else {
        window.location.href = '/#/login/bindInfo?back=true'
    }
}
util.processingData = function(data) {
    if (data.code == 1) {
        if (data.data && data.data.rtncode) {
            switch (data.data.rtncode) {
                case 60005:
                case 100401:
                    localStorage.removeItem('authorization');
                    if (sessionStorage.getItem('ua') == 'wechat') {
                        util.wechatLogin();
                    } else if (sessionStorage.getItem('ua') == 'iartIos' || sessionStorage.getItem('ua') == 'iartAndroid') {
                        appFunction.login();
                    } else {
                        window.location.href = '/#/login/bindInfo?back=true'
                    }
                    return false;
                    break;
                default:
                    return true;
                    break;
            }
        } else {
            return true;
        }
    } else {
        switch (data.code) {
            case 30103:
            case 30106:
            case 100504:
                localStorage.removeItem('authorization');
                if (sessionStorage.getItem('ua') == 'wechat') {
                    util.wechatLogin();
                } else if (sessionStorage.getItem('ua') == 'iartIos' || sessionStorage.getItem('ua') == 'iartAndroid') {
                    appFunction.login();
                } else {
                    window.location.href = '/#/login/bindInfo?back=true'
                }
                return false;
                break;
            default:
                return true;
                break;
        }
    }
}
util.wechatLogin = function() {
    var ua = sessionStorage.getItem('ua');
    switch (ua) {
        case 'wechat':
            if (window.location.host.indexOf('test') != -1 || window.location.host.indexOf('appb') != -1) {
                localStorage.setItem('enterUrl', window.location.href);
                window.location.href = window.location.origin + '/#/login/bindInfo?back=true'
            } else {
                var url = "https://im.iartschool.com:8443";
                axios.get(url + '/iart-api-authorize/wx/authorize/mp', {
                    params: {
                        redirect: window.location.origin+'/#/login/loginBoard',
                        scope: 'snsapi_userinfo',
                        _: (new Date()).getTime()
                    }
                }).then(res => {
                    localStorage.setItem('enterUrl', window.location.href);
                    window.location.href = res.data.data;
                }).catch(res => {})
            }
            break;
        case "iartAndroid":
        case "iartIos":
            appFunction.login();
            break;
        case "other":
        case "enterpriseWechat":
            localStorage.setItem('enterUrl', window.location.href);
            window.location.href = window.location.origin + '/#/login/bindInfo?back=true'
        default:
            break;
    }
}
util.replaceShare=function(url,replaceUrl){
    let newUrl='';
    let urlQuery={}
    let urlArray=url.split('?');
    newUrl=urlArray[0];
    if(urlArray.length>1){
       urlArray[1].split('&').forEach(item => {
        urlQuery[item.split('=')[0]]=item.split('=')[1]
        });
    }
    Object.assign(urlQuery,replaceUrl)
    for (const key in urlQuery) {
        newUrl+=(newUrl.indexOf('?')==-1?'?':'&')+key+'='+urlQuery[key]
    }
    return newUrl
}
util.shareLink = function(data) {
    var userinfo = store.state.state.userinfo;
    let url=data.url||location.href
    if (userinfo && userinfo.customercode) {
        url=util.replaceShare(url,{sharecode:userinfo.customercode})
    }
    return new Promise(function(resolve, reject) {
        if (sessionStorage.getItem('ua') == 'wechat') {
            wx.ready(function() {
                var obj = {
                    title: data.title,
                    desc: data.desc, // 分享描述
                    link: url,
                    // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: data.imgUrl||location.origin+location.pathname+'share.jpg', // 分享图标
                    success: function() {
                        // 设置成功
                        resolve();
                    },
                }
                wx.onMenuShareAppMessage(obj);
                wx.onMenuShareTimeline(obj);
            });
        }
    })
}
util.shareBox = function() {
    var shareBox = document.createElement('div');
    shareBox.setAttribute('class', 'shareBox');
    var img = document.createElement('img');
    img.setAttribute('src', shareTip);
    shareBox.appendChild(img)
    document.body.appendChild(shareBox);
    setTimeout(() => {
        var shareBox1 = document.querySelector('.shareBox');
        shareBox1.onclick = function() {
            document.body.removeChild(shareBox1);
        }
    }, 10);
}
util.goto = function(data) {
    var _this = data.this;
    var loginStatus = data.loginStatus;
    var url = data.url;
    var query = data.query;
    var type = data.type ? data.type : 'push';
    if (loginStatus) {
        if (!this.loginStatus()) {
            this.wechatLogin();
            return false;
        }
        _this.$router[type]({
            path: url,
            query: query ? query : {},
        });
    } else {
        _this.$router[type]({
            path: url,
            query: query ? query : {},
        });
    }
}
util.getUserAgent = function() {
    var ua = navigator.userAgent.toLowerCase();
    var userAgent = '';
    //延迟定时器 解决ios端存入缓慢
    setTimeout(() => {
        new Promise((resolve, reject) => {
            userAgent = typeof(window.android) != 'undefined' ? 'iartAndroid' : userAgent; //安卓环境
            userAgent = typeof(window.IARTSCHOOL) != 'undefined' ? 'iartIos' : userAgent; //ios环境
            userAgent = ua.indexOf('wxwork') != -1 ? 'enterpriseWechat' : userAgent; //企业微信
            userAgent = ua.indexOf('micromessenger') != -1 ? 'wechat' : userAgent; //微信

            resolve();
        }).then(res => {
            userAgent = userAgent ? userAgent : 'other';
            sessionStorage.setItem('ua', userAgent);
        })
    }, 1000)

}
util.downLoad = function(_this) {
    // var ua = sessionStorage.getItem('ua');
    // if (ua != 'iartAndroid' && ua != 'iartIos') {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        window.location.href = _this.$store.state.state.androidUrl;
    } else if (isiOS) {
        window.location.href = _this.$store.state.state.iosUrl;
    }
    // }
}
export default util;